import { create } from "zustand";

interface DownloadNotificationState {
  hasPendingDownload: boolean;
  setPendingDownload: (value: boolean) => void;
}

export const useDownloadNotificationStore = create<DownloadNotificationState>()(
  (set) => ({
    hasPendingDownload: false,
    setPendingDownload: (value) => set({ hasPendingDownload: value }),
  }),
);
